import ApiService from "../../util/ApiService";
import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
} from "../../constants/actionTypes";

export const fetchCategories = async (dispatch) => {
  dispatch({ type: GET_CATEGORIES_REQUEST });
  try {
    const response = await ApiService.get("/v1/alertCategories");
    dispatch({ type: GET_CATEGORIES_SUCCESS, payload: response.data });
  } catch {
    dispatch({ type: GET_CATEGORIES_ERROR });
  }
};
